module.exports = __webpack_public_path__ + "static/media/blue Ellipse.3a97c940.svg";